export default "assets/images/qualiopi-fc55c69d.png";